exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput:valid {\n    border-color: #39ad8f;\n}\ninput:invalid {\n    border-color: #a94442;\n}\nselect:invalid {\n    border-color: #a94442;\n}\nspan.error-message {\n    color: #a94442;\n}\n", ""]);

// exports
